import React from 'react';
import { motion } from 'framer-motion';
import { ClipboardCheckIcon, CalculatorIcon, MessageCircleIcon, PackageIcon, CalendarIcon, BookOpenIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function BonusSection() {
  const bonuses = [{
    title: 'Checklist de arranque',
    desc: '(para no olvidar lo importante).',
    icon: <CalculatorIcon className="w-10 h-10 text-gold-matte" data-id="element-44" />,
    number: '1',
    price: 5000,
    image: 'https://cdn.magicpatterns.com/uploads/gJFTPeXB6ueHZMDn4UJ2xD/mockup_bono_1.png'
  }, {
    title: 'Plantilla de costos y precios',
    desc: '(para que los números te queden claros).',
    icon: <MessageCircleIcon className="w-10 h-10 text-gold-matte" data-id="element-45" />,
    number: '2',
    price: 12000,
    image: 'https://cdn.magicpatterns.com/uploads/wkkPWZCtqcjHNiR765uhtU/mockup_bono_2.png'
  }, {
    title: 'Guiones para WhatsApp',
    desc: '(respuestas y seguimiento sin quedarte en blanco).',
    icon: <PackageIcon className="w-10 h-10 text-gold-matte" data-id="element-46" />,
    number: '3',
    price: 9000,
    image: 'https://cdn.magicpatterns.com/uploads/mW52ij2DS2w9gAAf2fmk1k/mockup_bono_3.png'
  }, {
    title: 'Paquetes y extras',
    desc: '(cómo armar combos que se venden mejor).',
    icon: <CalendarIcon className="w-10 h-10 text-gold-matte" data-id="element-47" />,
    number: '4',
    price: 7000,
    image: 'https://cdn.magicpatterns.com/uploads/6Ew1geT5a1QLfM4PiRykNP/mockup_bono_4.png'
  }, {
    title: 'Calendario de fechas',
    desc: '(para planificar campañas y picos de demanda).',
    icon: <BookOpenIcon className="w-10 h-10 text-gold-matte" data-id="element-48" />,
    number: '5',
    price: 6000,
    image: 'https://cdn.magicpatterns.com/uploads/begttdn7ZnmC8q5n4dFn4P/mockup_bono_5.png'
  }, {
    title: 'Fuentes y referencias',
    desc: '(para seguir aprendiendo con orden).',
    icon: <ClipboardCheckIcon className="w-10 h-10 text-gold-matte" data-id="element-49" />,
    number: '6',
    price: 7000,
    image: 'https://cdn.magicpatterns.com/uploads/tZejZ821sovU4bbDUnTRw1/mockup_bono_6.png'
  }];
  return <section className="py-20 md:py-28 bg-[#EFE8E0] relative" data-id="element-50">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-52">
          <div className="inline-block bg-red-600 text-white font-black text-xl md:text-2xl px-6 py-2 rounded-full mb-6 transform -rotate-2 shadow-lg animate-pulse" data-id="element-53">
            ¡GRATIS HOY CON TU COMPRA!
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-coffee-dark mb-6 font-heading" data-id="element-54">
            Además, llevás 6 bonos para implementar más rápido
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-55">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-xl border-t-8 border-gold-matte relative overflow-hidden group hover:-translate-y-2 transition-transform duration-300" data-id="element-56">
              <div className="absolute top-0 right-0 bg-cream-ivory text-taupe font-heading font-black text-8xl opacity-10 -mt-4 -mr-4 pointer-events-none" data-id="element-57">
                {bonus.number}
              </div>

              <a href="https://cocinaproductiva.com/cart" target="_blank" rel="noopener noreferrer" className="block cursor-pointer" data-id="element-58">
                <div className="mb-6 flex justify-center" data-id="element-59">
                  <img src={bonus.image} alt={`Bono ${bonus.number}: ${bonus.title}`} className="w-48 h-auto rounded-lg drop-shadow-xl group-hover:scale-105 transition-transform duration-300" data-id="element-60" />
                </div>
                <div className="mb-4 flex justify-center" data-id="element-61">{bonus.icon}</div>
                <h3 className="text-2xl font-bold text-coffee-dark font-heading leading-tight mb-2 text-center" data-id="element-62">
                  Bono {bonus.number}: <br data-id="element-63" />
                  <span className="text-coffee" data-id="element-64">{bonus.title}</span>
                </h3>
                <p className="text-center text-text-body font-medium italic" data-id="element-65">
                  {bonus.desc}
                </p>
                <div className="mt-4 text-center" data-id="element-66">
                  <p className="text-taupe font-bold text-sm mb-1" data-id="element-67">
                    Valor:{' '}
                    <span className="line-through" data-id="element-68">
                      ${bonus.price.toLocaleString('es-AR')}
                    </span>
                  </p>
                  <span className="inline-block bg-green-100 text-green-800 font-bold px-3 py-1 rounded text-sm" data-id="element-69">
                    ✅ INCLUIDO HOY GRATIS
                  </span>
                </div>
              </a>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto" data-id="element-70">
          <p className="text-2xl text-coffee-dark font-bold italic mb-10 bg-white p-6 rounded-xl shadow-sm border border-beige-sand" data-id="element-71">
            "No es 'más PDFs': son herramientas para ejecutar lo del ebook sin
            reinventar la rueda."
          </p>

          <CTAButton size="large" onClick={() => {
          const el = document.getElementById('offer-section');
          if (el) el.scrollIntoView({
            behavior: 'smooth'
          });else window.open('https://cocinaproductiva.com/cart', '_blank');
        }} data-id="element-72">
            QUIERO EL EBOOK + LOS 6 BONOS GRATIS
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}